const CptName = 'ComImg'
export let imgs_list = []
let is_prelaod = false
let all_img_urls = []
let index = 0

function formatData (node) {
  if (is_prelaod != this.options.preload) {
    is_prelaod = this.options.preload
    all_img_urls = []
    index = 0
  }
  // 设置懒加载回调
  let resolve, promise = new Promise(r => (resolve = r))
  const { width, height, margin } = clacImgWH.call(this, node)
  all_img_urls.push(node.dataset.original)
  return {
    data: {
      url: node.dataset.original,
      urls: all_img_urls,
      index: index++,
      width: width,
      height: height,
      margin: margin,
      next: [promise, resolve]
    },
    cpt: CptName
  }
}

function clacImgWH (node) {
  let src = node.dataset.original,
    width = node.dataset.width,
    height = node.dataset.height,
    margin = node.dataset.margin || 0,
    use_original_rect = node.dataset['original-rect']
  if (!!src && src != 'null' && src != 'undefined') {
    var rect = null
    if (width > 0 && height > 0) {
      rect = this.calcImageWidth(src, width, height, use_original_rect)
      return {
        width: typeof rect.width == 'string' ? rect.width.replace(/px/g, '') : rect.width,
        height: typeof rect.height == 'string' ? rect.height.replace(/px/g, '') : rect.height,
        margin: margin 
      }
    } else if (src.includes('cdn.max-c.com/stickers')) {
      var border = ~~(this.client_width * 0.3)
      return {
        width: border,
        height: border
      }
    }
    // if (i < 3) {
    //   imgs[i].src = src
    //   imgs[i].removeAttribute(this.currentLazyLoadAttr)
    //   imgs[i].removeAttribute('class')
    // }
  }
  return {}
}

let timer
const lazyLoadListener = () => {
  if (imgs_list.length == 0 || timer) return
  timer = setTimeout(() => {
    imgs_list = imgs_list.reduce((pre, [node_offset_top, setImgSrc]) => {
      if (node_offset_top < (window.scrollY + window.innerHeight + 1500)) {
        setImgSrc()
      } else {
        pre.push([node_offset_top, setImgSrc])
      }
      return pre
    }, [])
    window.clearTimeout(timer)
    timer = null
  }, 100);
}

export default {
  install (Vue) {
    Vue.component(CptName, require('./index.vue').default)
    window.hb__format['img'] = formatData
    window.addEventListener('scroll', lazyLoadListener)
  }
}